// Global Instructions Rule Applied!
//
// One cfg.fund_statuses row as it rides in the global-configs payload.
//
// A TOP-LEVEL key, not a synthesised lookup group: get_global_configs_v3
// already synthesises a group literally named 'Fundraising Status' from
// cfg.pipeline_statuses (the per-PROSPECT decision statuses), so a second
// group of that name would make getLookupOptions('Fundraising Status')
// ambiguous. lookup_details also has nowhere to carry the behaviour flags,
// and the flags are the whole point — every consumer reads THEM, never the
// name or the value.
import { z } from 'zod'

export const FundStatusModelSchema = z
  .object({
    id: z.string(),
    category: z.string(),
    name: z.string(),
    value: z.string().nullish(),
    sort_order: z.number().nullish(),
    is_open: z.boolean(),
    is_cancelled: z.boolean(),
    is_terminal: z.boolean()
  })
  .strict()

export type FundStatusModel = z.infer<typeof FundStatusModelSchema>
